// components/PersonaSelectorModal.jsx
import React from 'react';



const personas = [
  {
    "name": "Camila Rodríguez",
    "username": "camila.rodriguez@gmail.com",
    "password": "jkcommerce",
    "image_url": "/avatar_icons/camila.rodriguez_Icon.png",
    "description": "Trend-driven shopper, prefers relaxed-fit styles in Size L, spending in the mid to upper price range."
  },
  {
    "name": "Emily Parker",
    "username": "emily.parker@gmail.com",
    "password": "jkcommerce",
    "image_url": "/avatar_icons/emily.parker_Icon.png",
    "description": "Occasional shopper, prefers wide-leg fits in Size M, shopping within a mid-range budget."
  },
  {
    "name": "Rachel Sanders",
    "username": "rachel.sanders@gmail.com",
    "password": "jkcommerce",
    "image_url": "/avatar_icons/rachel.sanders_Icon.png",
    "description": "Frequent shopper, prioritizing comfort fits in Size L, lower to mid-range pricing."
  },
  {
    "name": "Abigail Coleman",
    "username": "abigail.coleman@gmail.com",
    "password": "jkcommerce",
    "image_url": "/avatar_icons/abigail.coleman_Icon.png",
    "description": "Trend-aware shopper, prefers slim-fit styles in Size S, spending within a mid to upper price range."
  },
  {
    "name": "Lauren Mitchell",
    "username": "lauren.mitchell@gmail.com",
    "password": "jkcommerce",
    "image_url": "/avatar_icons/lauren.mitchell_Icon.png",
    "description": "Frequent shopper, leans toward low waist fits in Size M, typically buying within a mid-range budget."
  },
  {
    "name": "Apsara Chaiyaporn",
    "username": "apsara.chaiyaporn@gmail.com",
    "password": "jkcommerce",
    "image_url": "/avatar_icons/apsara.chaiyaporn_Icon.png",
    "description": "Occasional shopper, prefers regular-fit styles in Size M, focusing on lower to mid-range pricing."
  },
  {
    "name": "Advika Gupta",
    "username": "advika.gupta@gmail.com",
    "password": "jkcommerce",
    "image_url": "/avatar_icons/advika.gupta_Icon.png",
    "description": "Style-conscious shopper, prefers tapered fits in Size M, spending mostly in the mid-range."
  },
  {
    "name": "May Phan",
    "username": "may.phan@gmail.com",
    "password": "jkcommerce",
    "image_url": "/avatar_icons/may.phan_Icon.png",
    "description": "Value-driven shopper, prefers relaxed-fit styles in Size S, prioritizing lower price points."
  },
  {
    "name": "Isabela Torres",
    "username": "isabela.torres@gmail.com",
    "password": "jkcommerce",
    "image_url": "/avatar_icons/isabela.torres_Icon.png",
    "description": "Frequent shopper, prefers straight-fit styles in Size L, spending across mid to upper price ranges."
  },
  {
    "name": "Megan Brooks",
    "username": "megan.brooks@gmail.com",
    "password": "jkcommerce",
    "image_url": "/avatar_icons/megan.brooks_Icon.png",
    "description": "Casual browser, prefers comfort-fit styles in Size L, shopping mainly within a mid-range budget."
  },
  {
    "name": "Ethan Miller",
    "username": "ethan.miller@gmail.com",
    "password": "jkcommerce",
    "image_url": "/avatar_icons/ethan.miller_Icon.png",
    "description": "Trend-driven shopper, prefers slim-fit styles in Size M, spending in the mid to upper price range."
  },
  {
    "name": "Carlos Ramirez",
    "username": "carlos.ramirez@gmail.com",
    "password": "jkcommerce",
    "image_url": "/avatar_icons/carlos.ramirez_Icon.png",
    "description": "Frequent shopper, favors relaxed-fit casualwear in Size L, typically shopping within a mid-range budget."
  },
  {
    "name": "Marcus Johnson",
    "username": "marcus.johnson@gmail.com",
    "password": "jkcommerce",
    "image_url": "/avatar_icons/marcus.johnson_Icon.png",
    "description": "Occasional shopper, prefers regular-fit essentials in Size XL, focusing on lower to mid-range pricing."
  },
  {
    "name": "Kenji Tanaka",
    "username": "kenji.tanaka@gmail.com",
    "password": "jkcommerce",
    "image_url": "/avatar_icons/kenji.tanaka_Icon.png",
    "description": "Value-conscious shopper, leans toward comfort-fit styles in Size L, prioritizing affordability and everyday basics."
  }
]
;

export default function PersonaSelectorModal({ onClose, onSelectPersona }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white w-full max-w-4xl p-6 rounded-lg shadow-lg max-h-[90vh] overflow-y-auto no-scrollbar">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-bold text-gray-900">Choose a User Persona</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 transition-colors"
            aria-label="Close"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
{/* 
        <h2 className="text-gray-600 text-center mb-8">
          Click on any persona to automatically fill the sign-in form
        </h2> */}
  


        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {personas.map((persona, index) => (
            <div
              key={persona.username}
              onClick={() => onSelectPersona(persona)}
              className="cursor-pointer group border border-gray-200 rounded-xl p-5 hover:shadow-lg transition-all duration-300 hover:border-gray-300"
            >
              <div className="flex items-start">
                <div className="flex-shrink-0">
                  <img
                    src={`${process.env.PUBLIC_URL || ''}${persona.image_url.trim()}`}
                    alt={persona.name}
                    className="w-16 h-16 rounded-full object-cover border-2 border-white shadow-md"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = 'data:image/svg+xml,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="%239ca3af"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg>');
                    }}
                  />
                </div>
                <div className="ml-4 flex-1">
                  <h3 className="font-bold text-lg text-gray-900 group-hover:text-blue-600 transition-colors">
                    {persona.name}
                  </h3>
                  <p className="text-gray-600 mt-1 text-sm leading-relaxed">
                    {persona.description}
                  </p>
                  <div className="mt-3 flex items-center justify-between">
                    <span className="text-xs bg-gray-100 px-2 py-1 rounded-full text-gray-700">
                      {persona.username}
                    </span>
                  
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 text-center text-sm text-gray-500">
          <p>Tip: Click any persona to auto-fill credentials</p>
        </div>
      </div>
    </div>
  );
}